import React from 'react';
import PropTypes from 'prop-types';
import { ActionIcon, Divider, Image } from '@mantine/core';
import { X } from 'tabler-icons-react';
import AppStack from '../../common/AppStack';
import AppFlexbox from '../../common/AppFlexbox';
import AppCard from '../../common/AppCard';
import AppText from '../../common/AppText';
import { ECOM_IMAGE_POSITION_LIST } from '../../../config/constants';

const PrintDesignEditorCanvasInfoCard = ({
  ecomExternalProduct,
  printTemplate,
  formState,
  printTemplateState,
  setFormState
}) => {
  const isVisible =
    !formState.showVariantSelect &&
    formState.showCanvasInfoCard &&
    !!ecomExternalProduct &&
    !!printTemplate;

  return (
    isVisible && (
      <AppStack
        style={{
          flex: 1,
          width: '100%',
          height: '100%',
          position: 'absolute',
          overflow: 'hidden',
          pointerEvents: 'none'
        }}
      >
        <AppStack
          style={{
            left: 0,
            top: 65,
            width: 275,
            maxHeight: '100%',
            pointerEvents: 'all',
            display: 'flex',
            position: 'absolute'
          }}
        >
          <AppCard
            radius={4}
            shadow="md"
            style={{
              width: '100%',
              height: '100%',
              padding: 0,
              display: 'flex'
            }}
            withBorder
          >
            <AppStack style={{ gap: 0 }}>
              <AppFlexbox
                style={{
                  padding: 8,
                  alignItems: 'center',
                  justifyContent: 'space-between'
                }}
              >
                <AppText style={{ fontSize: 18, fontWeight: 500 }}>
                  Product information
                </AppText>
                <ActionIcon
                  color="darks"
                  onClick={() => {
                    setFormState((c) => ({
                      ...c,
                      showCanvasInfoCard: !c.showCanvasInfoCard
                    }));
                  }}
                  variant="subtle"
                >
                  <X size={20} />
                </ActionIcon>
              </AppFlexbox>
              <Divider />
              <AppStack style={{ padding: 8, gap: 8 }}>
                <AppText style={{ fontSize: 14, fontWeight: 500 }}>
                  {printTemplateState.productName}
                </AppText>
                <AppFlexbox>
                  <AppStack style={{ width: 100, height: 100 }}>
                    <Image src={ecomExternalProduct.previewImage} />
                  </AppStack>
                  <AppStack style={{ gap: 0 }}>
                    <AppText style={{ fontSize: 13, color: '#666' }}>
                      {ecomExternalProduct.model}
                    </AppText>
                    <AppText style={{ fontSize: 13, color: '#666' }}>
                      Fulfilled by {ecomExternalProduct.vendorName}
                    </AppText>
                  </AppStack>
                </AppFlexbox>
                <Divider />
                <AppFlexbox
                  style={{
                    alignItems: 'center',
                    gap: 4,
                    justifyContent: 'space-between'
                  }}
                >
                  <AppText style={{ fontSize: 14, color: '#666' }}>
                    Canvas position
                  </AppText>
                  <AppText style={{ fontSize: 14, color: '#666' }}>
                    {ECOM_IMAGE_POSITION_LIST.find(
                      (type) =>
                        type.value.toString() ===
                        printTemplate.fkEcomImagePosition.toString()
                    )?.label || 'Front'}
                  </AppText>
                </AppFlexbox>
                <AppFlexbox
                  style={{
                    alignItems: 'center',
                    gap: 4,
                    justifyContent: 'space-between'
                  }}
                >
                  <AppText style={{ fontSize: 14, color: '#666' }}>
                    Canvas size
                  </AppText>
                  <AppText style={{ fontSize: 14, color: '#666' }}>
                    {printTemplate.imageWidthPx} x {printTemplate.imageHeightPx}{' '}
                    px
                  </AppText>
                </AppFlexbox>
                <AppFlexbox
                  style={{
                    alignItems: 'center',
                    gap: 4,
                    justifyContent: 'space-between'
                  }}
                >
                  <AppText style={{ fontSize: 14, color: '#666' }}>DPI</AppText>
                  <AppText style={{ fontSize: 14, color: '#666' }}>300</AppText>
                </AppFlexbox>
                <AppFlexbox
                  style={{
                    alignItems: 'center',
                    gap: 4,
                    justifyContent: 'space-between'
                  }}
                >
                  <AppText style={{ fontSize: 14, color: '#666' }}>
                    Product size
                  </AppText>
                  <AppText style={{ fontSize: 14, color: '#666' }}>
                    {printTemplate.sizeOption}
                  </AppText>
                </AppFlexbox>
              </AppStack>
            </AppStack>
          </AppCard>
        </AppStack>
      </AppStack>
    )
  );
};

PrintDesignEditorCanvasInfoCard.propTypes = {
  formState: PropTypes.object.isRequired,
  printTemplateState: PropTypes.object.isRequired,
  setFormState: PropTypes.func.isRequired,
  ecomExternalProduct: PropTypes.object,
  printTemplate: PropTypes.object
};

export default PrintDesignEditorCanvasInfoCard;
